// initial state
const state = {
  userData: {},
  myCompany: {},
  vehicles: [],
  users: [],
  drivers: [],
  requests: [],
  dispatches: [],
  bundles: [],
  companies: [],
  notifications: [],
  userSettings: [],
  groups: [],
  // Permissions
  permDash: {
    create: false,
    delete: false,
    read: true,
    write: false
  },
  permTrack: {
    create: false,
    delete: false,
    read: false,
    write: false
  },
  permNotif: {
    create: false,
    delete: false,
    read: false,
    write: false
  },
  permReq: {
    create: false,
    delete: false,
    read: false,
    write: false
  },
  permDispatches: {
    create: false,
    delete: false,
    read: false,
    write: false
  },
  permVeh: {
    create: false,
    delete: false,
    read: false,
    write: false
  },
  permEmployees: {
    create: false,
    delete: false,
    read: false,
    write: false
  },
  permPartners: {
    create: false,
    delete: false,
    read: false,
    write: false
  }
}

// getters
const getters = {
  userData: (state, getters, rootState) => {
    return state.userData;
  },
  myCompany: (state, getters, rootState) => {
    return state.myCompany;
  },
  companies: (state, getters, rootState) => {
    return state.companies;
  },
  notifications: (state, getters, rootState) => {
    return state.notifications;
  },
  dispatches: (state, getters, rootState) => {
    return state.dispatches;
  },
  bundles: (state, getters, rootState) => {
    return state.bundles;
  },
  requests: (state, getters, rootState) => {
    return state.requests;
  },
  vehicles: (state, getters, rootState) => {
    return state.vehicles;
  },
  users: (state, getters, rootState) => {
    return state.users;
  },
  drivers: (state, getters, rootState) => {
    return state.drivers;
  },
  groups: (state, getters, rootState) => {
    return state.groups;
  },
  userSettings: (state, getters, rootState) => {
    return state.userSettings;
  },
  permDash: (state, getters, rootState) => {
    return state.permDash;
  },
  permTrack: (state, getters, rootState) => {
    return state.permTrack;
  },
  permNotif: (state, getters, rootState) => {
    return state.permNotif;
  },
  permReq: (state, getters, rootState) => {
    return state.permReq;
  },
  permDispatches: (state, getters, rootState) => {
    return state.permDispatches;
  },
  permVeh: (state, getters, rootState) => {
    return state.permVeh;
  },
  permEmployees: (state, getters, rootState) => {
    return state.permEmployees;
  },
  permPartners: (state, getters, rootState) => {
    return state.permPartners;
  },
}

// actions
const actions = {
  setUserData({
    state,
    commit,
  }, payload) {
    commit('setUserData', {
      userData: payload.userData
    });
  },
  setMyCompany({
    state,
    commit,
  }, payload) {
    commit('setMyCompany', {
      myCompany: payload.myCompany
    });
  },
  updateUserData({
    state,
    commit,
  }, payload) {
    commit('updateUserData', {
      userData: payload.userData
    });
  },
  updateMyCompany({
    state,
    commit,
  }, payload) {
    commit('updateMyCompany', {
      myCompany: payload.myCompany
    });
  },
  destroyStorage({
    state,
    commit,
  }, payload) {
    commit('destroyStorage');
  },
  setCompanies({
    state,
    commit,
  }, payload) {
    commit('setCompanies', {
      companies: payload.companies
    });
  },
  addCompany({
    state,
    commit,
  }, payload) {
    commit('addCompany', {
      company: payload.company
    });
  },
  addNotifications({
    state,
    commit,
  }, payload) {
    commit('addNotifications', {
      notifications: payload.notifications
    });
  },
  updateCompanyStatus({
    state,
    commit,
  }, payload) {
    commit('updateCompanyStatus', {
      uid: payload.uid,
      status: payload.status,
    });
  },
  updateCompanyService({
    state,
    commit,
  }, payload) {
    commit('updateCompanyService', {
      uid: payload.uid,
      vehicleTypeIds: payload.vehicleTypeIds,
    });
  },
  setDispatches({
    state,
    commit,
  }, payload) {
    commit('setDispatches', {
      dispatches: payload.dispatches
    });
  },
  addDispatch({
    state,
    commit,
  }, payload) {
    commit('addDispatch', {
      dispatch: payload.dispatch
    });
  },
  addDispatches({
    state,
    commit,
  }, payload) {
    commit('addDispatches', {
      dispatches: payload.dispatches
    });
  },
  updateDispatch({
    state,
    commit,
  }, payload) {
    commit('updateDispatch', {
      id: payload.id,
      property: payload.property,
      value: payload.value,
    });
  },
  updateDispatchByUid({
    state,
    commit,
  }, payload) {
    commit('updateDispatchByUid', {
      uid: payload.uid,
      properties: payload.properties,
    });
  },
  deleteDispatchByUid({
    state,
    commit,
  }, payload) {
    commit('deleteDispatchByUid', {
      uid: payload.uid,
    });
  },
  setBundles({
    state,
    commit,
  }, payload) {
    commit('setBundles', {
      bundles: payload.bundles
    });
  },
  addBundle({
    state,
    commit,
  }, payload) {
    commit('addBundle', {
      bundle: payload.bundle
    });
  },
  updateBundleByUid({
    state,
    commit,
  }, payload) {
    commit('updateBundleByUid', {
      uid: payload.uid,
      properties: payload.properties,
    });
  },
  deleteBundleByUid({
    state,
    commit,
  }, payload) {
    commit('deleteBundleByUid', {
      uid: payload.uid,
    });
  },
  setRequests({
    state,
    commit,
  }, payload) {
    commit('setRequests', {
      requests: payload.requests
    });
  },
  addRequest({
    state,
    commit,
  }, payload) {
    commit('addRequest', {
      request: payload.request
    });
  },
  addRequests({
    state,
    commit,
  }, payload) {
    commit('addRequests', {
      requests: payload.requests
    });
  },
  updateRequest({
    state,
    commit,
  }, payload) {
    commit('updateRequest', {
      id: payload.id,
      property: payload.property,
      value: payload.value,
    });
  },
  updateRequestByUid({
    state,
    commit,
  }, payload) {
    commit('updateRequestByUid', {
      uid: payload.uid,
      properties: payload.properties,
    });
  },
  deleteRequestByUid({
    state,
    commit,
  }, payload) {
    commit('deleteRequestByUid', {
      uid: payload.uid,
    });
  },
  setVehicles({
    state,
    commit,
  }, payload) {
    commit('setVehicles', {
      vehicles: payload.vehicles
    });
  },
  addVehicle({
    state,
    commit,
  }, payload) {
    commit('addVehicle', {
      vehicle: payload.vehicle
    });
  },
  updateVehicle({
    state,
    commit,
  }, payload) {
    commit('updateVehicle', {
      uid: payload.uid,
      data: payload.data,
    });
  },
  delVehicle({
    state,
    commit,
  }, payload) {
    commit('delVehicle', {
      uid: payload.uid
    });
  },
  setUsers({
    state,
    commit,
  }, payload) {
    commit('setUsers', {
      users: payload.users
    });
  },
  addUser({
    state,
    commit,
  }, payload) {
    commit('addUser', {
      user: payload.user
    });
  },
  updateUser({
    state,
    commit,
  }, payload) {
    commit('updateUser', {
      uid: payload.uid,
      data: payload.data
    });
  },
  delUser({
    state,
    commit,
  }, payload) {
    commit('delUser', {
      uid: payload.uid
    });
  },
  updateUsers({
    state,
    commit,
  }, payload) {
    commit('updateUsers', {
      users: payload.users
    });
  },
  addDriver({
    state,
    commit,
  }, payload) {
    commit('addDriver', {
      driver: payload.driver
    });
  },
  addDrivers({
    state,
    commit,
  }, payload) {
    commit('addDrivers', {
      drivers: payload.drivers
    });
  },
  setUserSettings({
    state,
    commit,
  }, payload) {
    commit('setUserSettings', {
      userSettings: payload.userSettings
    });
  },
  setGroups({
    state,
    commit,
  }, payload) {
    commit('setGroups', {
      groups: payload.groups
    });
  },
}

// mutations
const mutations = {
  setUserData(state, {
    userData
  }) {
    state.userData = userData;

    if (userData.permissions == null)
      return;

    let perms = userData.permissions.split(',');
    // Dispatches
    state.permDispatches.read = perms.indexOf('dispatch:all') > -1 || perms.indexOf('dispatch:read') > -1;
    state.permDispatches.create = perms.indexOf('dispatch:all') > -1 || perms.indexOf('dispatch:create') > -1;
    state.permDispatches.write = perms.indexOf('dispatch:all') > -1 || perms.indexOf('dispatch:write') > -1;
    state.permDispatches.delete = perms.indexOf('dispatch:all') > -1 || perms.indexOf('dispatch:delete') > -1;
    // Employees
    state.permEmployees.read = perms.indexOf('user:all') > -1 || perms.indexOf('user:read') > -1;
    state.permEmployees.create = perms.indexOf('user:all') > -1 || perms.indexOf('user:create') > -1;
    state.permEmployees.write = perms.indexOf('user:all') > -1 || perms.indexOf('user:write') > -1;
    state.permEmployees.delete = perms.indexOf('user:all') > -1 || perms.indexOf('user:delete') > -1;
    // Notifications
    state.permNotif.read = perms.indexOf('notification:all') > -1 || perms.indexOf('notification:read') > -1;
    state.permNotif.create = perms.indexOf('notification:all') > -1 || perms.indexOf('notification:create') > -1;
    state.permNotif.write = perms.indexOf('notification:all') > -1 || perms.indexOf('notification:write') > -1;
    state.permNotif.delete = perms.indexOf('notification:all') > -1 || perms.indexOf('notification:delete') > -1;
    // Partners
    state.permPartners.read = perms.indexOf('company:all') > -1 || perms.indexOf('company:read') > -1;
    state.permPartners.create = perms.indexOf('company:all') > -1 || perms.indexOf('company:create') > -1;
    state.permPartners.write = perms.indexOf('company:all') > -1 || perms.indexOf('company:write') > -1;
    state.permPartners.delete = perms.indexOf('company:all') > -1 || perms.indexOf('company:delete') > -1;
    // Requests
    state.permReq.read = perms.indexOf('request:all') > -1 || perms.indexOf('request:read') > -1;
    state.permReq.create = perms.indexOf('request:all') > -1 || perms.indexOf('request:create') > -1;
    state.permReq.write = perms.indexOf('request:all') > -1 || perms.indexOf('request:write') > -1;
    state.permReq.delete = perms.indexOf('request:all') > -1 || perms.indexOf('request:delete') > -1;
    // Tracking
    state.permTrack.read = perms.indexOf('tracking:all') > -1 || perms.indexOf('tracking:read') > -1;
    state.permTrack.create = perms.indexOf('tracking:all') > -1 || perms.indexOf('tracking:create') > -1;
    state.permTrack.write = perms.indexOf('tracking:all') > -1 || perms.indexOf('tracking:write') > -1;
    state.permTrack.delete = perms.indexOf('tracking:all') > -1 || perms.indexOf('tracking:delete') > -1;
    // Vehicles
    state.permVeh.read = perms.indexOf('vehicle:all') > -1 || perms.indexOf('vehicle:read') > -1;
    state.permVeh.create = perms.indexOf('vehicle:all') > -1 || perms.indexOf('vehicle:create') > -1;
    state.permVeh.write = perms.indexOf('vehicle:all') > -1 || perms.indexOf('vehicle:write') > -1;
    state.permVeh.delete = perms.indexOf('vehicle:all') > -1 || perms.indexOf('vehicle:delete') > -1;
    // Dashboard
    state.permDash.read = perms.indexOf('dashboard:all') > -1 || perms.indexOf('dashboard:read') > -1;
    state.permDash.create = perms.indexOf('dashboard:all') > -1 || perms.indexOf('dashboard:create') > -1;
    state.permDash.write = perms.indexOf('dashboard:all') > -1 || perms.indexOf('dashboard:write') > -1;
    state.permDash.delete = perms.indexOf('dashboard:all') > -1 || perms.indexOf('dashboard:delete') > -1;
  },
  setMyCompany(state, {
    myCompany
  }) {
    state.myCompany = myCompany;
  },
  updateUserData(state, {
    userData
  }) {
    state.userData.email = userData.email != null ? userData.email : state.userData.email;
    state.userData.image = userData.image != null ? userData.image : state.userData.image;
    state.userData.isAdmin = userData.isAdmin != null ? userData.isAdmin : state.userData.isAdmin;
    state.userData.language = userData.language != null ? userData.language : state.userData.language;
    state.userData.name = userData.name != null ? userData.name : state.userData.name;
    state.userData.phoneNumber = userData.phoneNumber != null ? userData.phoneNumber : state.userData.phoneNumber;
    state.userData.role = userData.role != null ? userData.role : state.userData.role;

    let result = state.users.filter(function (obj) {
      return userData.uid == obj.uid;
    })
    if (result.length == 1) {
      result[0].email = userData.email != null ? userData.email : result[0].email;
      result[0].image = userData.image != null ? userData.image : result[0].image;
      result[0].phoneNumber = userData.phoneNumber != null ? userData.phoneNumber : result[0].phoneNumber;
    }
  },
  updateMyCompany(state, {
    myCompany
  }) {
    state.myCompany.address = myCompany.address != null ? myCompany.address : state.myCompany.address;
    state.myCompany.adminEmail = myCompany.adminEmail != null ? myCompany.adminEmail : state.myCompany.adminEmail;
    state.myCompany.employeeNumber = myCompany.employeeNumber != null ? myCompany.employeeNumber : state.myCompany.employeeNumber;
    state.myCompany.logo = myCompany.logo != null ? myCompany.logo : state.myCompany.logo;
    state.myCompany.phoneNumber = myCompany.phoneNumber != null ? myCompany.phoneNumber : state.myCompany.phoneNumber;
    state.myCompany.vehicleNumber = myCompany.vehicleNumber != null ? myCompany.vehicleNumber : state.myCompany.vehicleNumber;

    /***** User Data info */
    state.userData.company.address = myCompany.address != null ? myCompany.address : state.userData.company.address;
    state.userData.company.logo = myCompany.logo != null ? myCompany.logo : state.userData.company.logo;
  },
  destroyStorage(state) {
    state.vehicles = [];
    state.users = [];
    state.drivers = [];
    state.userData = {};
    state.requests = [];
    state.dispatches = [];
    state.companies = [];
    state.notifications = [];
    state.userSettings = [];
    state.groups = [];
    // Permissions
    state.permDash = {
      create: false,
      delete: false,
      read: true,
      write: false
    }
    state.permTrack = {
      create: false,
      delete: false,
      read: false,
      write: false
    };
    state.permNotif = {
      create: false,
      delete: false,
      read: false,
      write: false
    };
    state.permReq = {
      create: false,
      delete: false,
      read: false,
      write: false
    };
    state.permDispatches = {
      create: false,
      delete: false,
      read: false,
      write: false
    };
    state.permVeh = {
      create: false,
      delete: false,
      read: false,
      write: false
    };
    state.permEmployees = {
      create: false,
      delete: false,
      read: false,
      write: false
    };
    state.permPartners = {
      create: false,
      delete: false,
      read: false,
      write: false
    };
  },
  setCompanies(state, {
    companies
  }) {
    state.companies = companies;
  },
  addCompany(state, {
    company
  }) {
    state.companies.push(company);
  },
  updateCompanyStatus(state, {
    uid,
    status
  }) {
    let company = state.companies.filter(function (obj) {
      return obj.uid == uid;
    });

    if (company.length > 0)
      company[0].status = status;
  },
  updateCompanyService(state, {
    uid,
    vehicleTypeIds
  }) {
    let company = state.companies.filter(function (obj) {
      return obj.uid == uid;
    });

    if (company.length > 0)
      company[0].vehicleTypeIds = vehicleTypeIds;
  },
  addNotifications(state, {
    notifications
  }) {
    for (let notif of notifications) {
      let result = state.notifications.filter(function (obj) {
        return obj.id == notif.id;
      })

      if (result.length == 0) {
        state.notifications.push(notif);
      }
    }
  },
  setDispatches(state, {
    dispatches
  }) {
    state.dispatches = dispatches;
  },
  addDispatch(state, {
    dispatch
  }) {
    let result = state.dispatches.filter(function (obj) {
      return (obj.uid == dispatch.uid) || (obj.id == dispatch.id);
    })

    if (result.length == 0)
      state.dispatches.push(dispatch);
  },
  addDispatches(state, {
    dispatches
  }) {
    let uids = state.dispatches.map(function (obj) {
      return obj.requestUid;
    }),
      result = dispatches.filter(function (obj) {
        return uids.indexOf(obj.uid) == -1;
      })

    if (result.length > 0)
      state.dispatches = state.dispatches.concat(result);
  },
  updateDispatch(state, {
    id,
    property,
    value,
  }) {
    let result = state.dispatches.filter(function (obj) {
      return obj.id == id;
    })

    if (result.length != 1) return;

    if (!(property in result[0])) return;

    result[0][property] = value;
  },
  updateDispatchByUid(state, {
    uid,
    properties,
  }) {
    let result = state.dispatches.filter(function (obj) {
      return obj.uid == uid;
    })

    if (result.length != 1) return;

    for (let property in properties) {
      if (!properties.hasOwnProperty(property)) return;

      if (property in result[0]) {
        result[0][property] = properties[property];
      }
    }
  },
  deleteDispatchByUid(state, {
    uid
  }) {
    let result = state.dispatches.filter(function (obj) {
      return obj.uid == uid;
    })

    if (result.length != 1) return;

    let index = state.dispatches.indexOf(result[0]);
    state.dispatches.splice(index, 1);
  },
  setBundles(state, {
    bundles
  }) {
    state.bundles = bundles;
  },
  addBundle(state, {
    bundle
  }) {
    let result = state.bundles.filter(function (obj) {
      return (obj.uid == bundle.uid);
    })

    if (result.length == 0)
      state.bundles.push(bundle);
  },
  updateBundleByUid(state, {
    uid,
    properties,
  }) {
    let result = state.bundles.filter(function (obj) {
      return obj.uid == uid;
    })

    if (result.length != 1) return;

    for (let property in properties) {
      if (!properties.hasOwnProperty(property)) return;

      if (property in result[0]) {
        result[0][property] = properties[property];
      }
    }
  },
  deleteBundleByUid(state, {
    uid
  }) {
    let result = state.bundles.filter(function (obj) {
      return obj.uid == uid;
    })

    if (result.length != 1) return;

    let index = state.bundles.indexOf(result[0]);
    state.bundles.splice(index, 1);
  },
  setRequests(state, {
    requests
  }) {
    state.requests = requests;
  },
  addRequest(state, {
    request
  }) {
    let result = state.requests.filter(function (obj) {
      return (obj.uid == request.uid) || (obj.id == request.id);
    })

    if (result.length == 0)
      state.requests.push(request);
  },
  addRequests(state, {
    requests
  }) {
    let uids = state.requests.map(function (obj) {
      return obj.uid;
    }),
      result = requests.filter(function (obj) {
        return uids.indexOf(obj.uid) == -1;
      })

    if (result.length > 0)
      state.requests = state.requests.concat(result);
  },
  updateRequest(state, {
    id,
    property,
    value,
  }) {
    let result = state.requests.filter(function (obj) {
      return obj.id == id;
    })

    if (result.length != 1) return;

    if (!(property in result[0])) return;

    result[0][property] = value;
  },
  updateRequestByUid(state, {
    uid,
    properties,
  }) {
    let result = state.requests.filter(function (obj) {
      return obj.uid == uid;
    })

    if (result.length != 1) return;

    for (let property in properties) {
      if (!properties.hasOwnProperty(property)) return;

      if (property in result[0]) {
        result[0][property] = properties[property];
      }
    }
  },
  deleteRequestByUid(state, {
    uid
  }) {
    let result = state.requests.filter(function (obj) {
      return obj.uid == uid;
    })

    if (result.length != 1) return;

    let index = state.requests.indexOf(result[0]);
    state.requests.splice(index, 1);
  },
  setVehicles(state, {
    vehicles
  }) {
    state.vehicles = vehicles;
  },
  addVehicle(state, {
    vehicle
  }) {
    state.vehicles.push(vehicle);
  },
  updateVehicle(state, {
    uid,
    data,
  }) {
    let result = state.vehicles.filter(function (obj) {
      return obj.uid == uid;
    });

    if (result.length != 1) return;

    let index = state.vehicles.indexOf(result[0]);
    if (index == -1) return;

    state.vehicles[index] = data;
  },
  delVehicle(state, {
    uid,
  }) {
    let result = state.vehicles.filter(function (obj) {
      return obj.uid == uid;
    });

    if (result.length != 1) return;

    let index = state.vehicles.indexOf(result[0]);
    if (index == -1) return;

    state.vehicles.splice(index, 1);
  },
  setUsers(state, {
    users
  }) {
    state.users = users;
  },
  addUser(state, {
    user
  }) {
    state.users.push(user);
  },
  updateUser(state, {
    uid,
    data,
  }) {
    let result = state.users.filter(function (obj) {
      return obj.uid == uid;
    });

    if (result.length != 1) return;

    let index = state.users.indexOf(result[0]);
    if (index == -1) return;

    state.users[index] = data;
  },
  delUser(state, {
    uid,
  }) {
    let result = state.users.filter(function (obj) {
      return obj.uid == uid;
    });

    if (result.length != 1) return;

    let index = state.users.indexOf(result[0]);
    if (index == -1) return;

    state.users.splice(index, 1);
  },
  updateUsers(state, {
    users
  }) {
    for (let user of users) {
      let result = state.users.filter(function (obj) {
        return user.uid == obj.uid;
      })
      if (result.length == 1) {
        result[0].email = user.email;
        result[0].image = user.image;
        result[0].phoneNumber = user.phoneNumber;
      }
    }
  },
  addDriver(state, {
    driver
  }) {
    state.drivers.push(driver);
  },
  addDrivers(state, {
    drivers
  }) {
    state.drivers.push.apply(state.drivers, drivers);
  },
  setUserSettings(state, {
    userSettings
  }) {
    state.userSettings = userSettings;
  },
  setGroups(state, {
    groups
  }) {
    state.groups = groups;
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
